import React from 'react'
import classNames from 'classnames'

import { COURSE_COMMENTS_CLASS_NAMES } from '@elo-kit/constants/customCss.constants'

const DefaultCommentsContainer = ({ children }) => (
  <div className={classNames('white-widget', 'lesson-comments', COURSE_COMMENTS_CLASS_NAMES.containerClassName)}>
    <span className='discussion'>{I18n.t('shared.common.discussion')}</span>
    {children}
  </div>
)

export default DefaultCommentsContainer
